import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  skipNav: {
    position: 'fixed',
    top: theme.spacing(0),
    left: '45%',
    padding: theme.spacing(1),
    display: 'inline-block',
    zIndex: theme.zIndex.appBar + 1,
    color: theme.palette.common.white,
    background: theme.palette.primary.main,
    opacity: 0,
    transform: 'translateY(-320%)',
    transition: 'transform .15s ease-out, opacity 0ms linear .15s',

    '&:focus': {
      transform: 'translateY(0)',
      transition: 'transform .2s ease-out',
      opacity: 1,
      color: theme.palette.common.white,
      outlineOffset: 0,
    },
  },
}))

const SkipNav = ({ targetId }: { targetId: string }) => {
  const classes = useStyles()
  return !targetId ? null : (
    <a
      href={`#${targetId}`}
      className={classes.skipNav}
    >
      Skip to main content
    </a>
  )
}

export default SkipNav
